<template>
  <Disclosure
    v-slot="{ open }"
    as="nav"
    :class="[hasToggleSticky ? 'bg-gray-950/95' : 'bg-[aquamarine]/70', 'sticky top-0 w-full z-50']"
    :style="[
      hasToggleSticky ? 'backdrop-filter: blur(50px); background-image: url(`/images/default-header-bg-2.svg`);background-position: bottom;background-attachment: scroll;background-repeat: repeat;background-size: cover;'
      : 'bg-white',
    ]
    "
  >
    <!--  fixed top-0% will create a dropdown overlay, sticky will push down  -->
    <div
      :class="[hasToggleSticky ? 'bg-gray-950/65' : 'bg-[aquamarine]/70']"
      style="backdrop-filter: blur(5px)"
    >
      <div class="container mx-auto py-2 px-2">
        <div class="relative flex h-14 items-center justify-between">
          <div class="absolute inset-y-0 left-0 flex items-center lg:hidden">
            <!-- Mobile menu button-->
            <DisclosureButton
              class="relative inline-flex items-center justify-center rounded-md p-2 text-green-400 hover:bg-green-700 hover:text-yellow-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-600"
            >
              <span class="absolute -inset-0.5" />
              <span class="sr-only">Open main menu</span>
              <Bars3Icon
                v-if="!open"
                class="block h-6 w-6"
                aria-hidden="true"
              />
              <XMarkIcon
                v-else
                class="block h-6 w-6"
                aria-hidden="true"
              />
            </DisclosureButton>
          </div>
          <div
            class="ml-12 md:ml-0 flex flex-1 items-center justify-end lg:justify-between"
          >
            <router-link
              to="/"
              class="flex flex-shrink-0 items-center mr-auto lg:mr-0 ml-auto md:pl-28 lg:ml-0 pl-0 lg:pl-0"
            >
              <span class="block mr-2">
                <svg
                  height="32"
                  viewBox="0 0 15 15"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  :style="[hasToggleSticky ? 'fill: red' : 'fill: #e1b53e']"
                ><path
                  clip-rule="evenodd"
                  d="m0 7.5c0-4.14214 3.35786-7.5 7.5-7.5 4.1421 0 7.5 3.35786 7.5 7.5 0 4.1421-3.3579 7.5-7.5 7.5-4.14214 0-7.5-3.3579-7.5-7.5zm1 0c0-3.25907 2.39856-5.95793 5.52672-6.42762l.47329.23665v.38196l-.72361.36181c-.15941.0797-.26435.23825-.27542.41614-.01108.17789.07338.34823.22168.44709l1.5 1c.08213.05476.17864.08398.27735.08398h.5c.27614 0 .5-.22386.5-.5v-.5h.5v.5c0 .13261.05268.25978.14645.35355l.35354.35356v.58578l-.2071.20711h-.67486l-1.89442-.94721c-.14077-.07039-.30645-.07039-.44722 0l-.89442.44721h-1c-.22943 0-.42942.15615-.48507.37873l-.5 2c-.0426.17039.00733.35063.13152.47482l1.5 1.5c.038.038.08188.06963.12994.09366l.72361.3618v1.19098c0 .1326.05268.2598.14645.3536l.35355.3535v.7929c0 .0776.01807.1542.05279.2236l.5 1c.08469.1694.25782.2764.44721.2764h1c.16718 0 .32329-.0835.41603-.2226l1-1.5c.0115-.0173.02191-.0352.03118-.0538l.49998-1c.0347-.0694.0528-.146.0528-.2236v-.83332l1.4-1.86667c.1136-.15151.1319-.35422.0472-.52361l-.1382-.27639h.691c.2762 0 .5-.22386.5-.5v-.5h.8261c.1137.48152.1739.98372.1739 1.49999 0 3.5899-2.9101 6.5-6.5 6.5-3.58985 0-6.5-2.9101-6.5-6.5z"
                  fill-rule="evenodd"
                /></svg>
              </span>
              <span :class="['block text-lg md:text-2xl font-extrabold logo-title', hasToggleSticky ? 'text-amber-400' : 'text-gray-800']">
                GhConnect
              </span>
            </router-link>
            <div class="flex lg:flex-1 items-center justify-end">
              <div class="hidden lg:ml-6 lg:block">
                <div class="flex space-x-1">
                  <template
                    v-for="item in navigation"
                    :key="item.id"
                  >
                    <!-- Home Link -->
                    <router-link
                      v-if="item.type === 'Home'"
                      v-slot="{ href, navigate, isActive }"
                      :to="{ name: 'Home' }"
                      custom
                    >
                      <a
                        :href="href"
                        :class="[
                          isActive
                            ? 'text-amber-600 hover:text-red-600'
                            : 'text-gray-800 hover:text-amber-600',
                          'font-bold duration-500 transition-all',
                          'p-2 text-base xl:text-lg block cursor-pointer'
                        ]"
                        @click="(e) => { e.preventDefault(); navigate(); setCurrentSectorAndCategory(item, null); }"
                      >
                        {{ item.name }}
                      </a>
                    </router-link>

                    <!-- About Link -->
                    <router-link
                      v-else-if="item.type === 'About'"
                      v-slot="{ href, navigate, isActive }"
                      :to="{ name: 'About' }"
                      custom
                    >
                      <a
                        :href="href"
                        :class="[
                          isActive
                            ? 'text-amber-600 hover:text-red-600'
                            : 'text-gray-800 hover:text-amber-600',
                          'font-bold duration-500 transition-all',
                          'p-2 text-base xl:text-lg block cursor-pointer'
                        ]"
                        @click="(e) => { e.preventDefault(); navigate(); }"
                      >
                        {{ item.name }}
                      </a>
                    </router-link>

                    <!-- Sector Links -->
                    <router-link
                      v-else
                      v-slot="{ href, navigate, isActive }"
                      :to="{ name: 'Sector', params: { sector: item.slug } }"
                      custom
                    >
                      <a
                        :href="href"
                        :class="[
                          isActive || route.params.sector === item.slug
                            ? 'text-amber-600 hover:text-red-600'
                            : 'text-gray-800 hover:text-amber-600',
                          'font-bold duration-500 transition-all',
                          'p-2 text-base xl:text-lg block cursor-pointer'
                        ]"
                        @click="(e) => { e.preventDefault(); navigate(); setCurrentSectorAndCategory(item, null); }"
                      >
                        {{ item.name }}
                      </a>
                    </router-link>
                  </template>
                </div>
              </div>
              <div
                class="md:block ml-5"
              >
                <div class="flex space-x-2 items-center justify-between">
                  <button class="rounded-full md:rounded-3xl flex items-center p-1 md:px-3 md:y-2 text-sm lg:text-lg font-semibold bg-red-600 text-white border border-red-600 hover:border-red-700 hover:bg-red-700 transition-all duration-500">
                    <MagnifyingGlassIcon class="h-6 w-6" />
                    <span class="hidden md:block">Search</span>
                  </button>
                </div>
              </div>
              <div
                v-if="isGuest"
                class="ml-3 md:block"
              >
                <router-link
                  v-for="item in authNavigation"
                  :key="item.name"
                  :to="`/${item.href}`"
                  :aria-current="item.current ? 'page' : undefined"
                >
                  <ArrowRightStartOnRectangleIcon class="h-9 w-9 md:h-10 md:w-10 text-gray-600 hover:text-green-600 transition-all duration-500" />
                </router-link>
              </div>
            </div>
          </div>
          <div
            v-if="!isGuest"
            class="absolute inset-y-0 right-0 flex items-center pr-2 md:static md:inset-auto md:ml-6 md:pr-0"
          >
            <button
              type="button"
              class="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-yellow-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
            >
              <span class="absolute -inset-1.5" />
              <span class="sr-only">View notifications</span>
              <BellIcon
                class="h-6 w-6"
                aria-hidden="true"
              />
            </button>

            <!-- Profile dropdown -->
            <Menu
              as="div"
              class="relative ml-3"
            >
              <div>
                <MenuButton
                  class="relative flex rounded-full bg-gray-800 text-base xl:text-lg focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                >
                  <span class="absolute -inset-1.5" />
                  <span class="sr-only">Open user menu</span>
                  <img
                    class="h-8 w-8 rounded-full"
                    :src="authUser?.attributes?.avatar"
                    alt=""
                  >
                </MenuButton>
              </div>
              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                >
                  <MenuItem v-slot="{ active }">
                    <a
                      :href="profileUrl"
                      :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']"
                    >Profile</a>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <a
                      :href="dashboardUrl"
                      :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']"
                    >Dashboard</a>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <a
                      href="#"
                      :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']"
                      @click="authStore.logout"
                    >Sign
                      out</a>
                  </MenuItem>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
      </div>
    </div>

    <DisclosurePanel class="lg:hidden">
      <div class="space-y-1 px-2 pb-3 pt-2">
        <DisclosureButton>
          <template
            v-for="item in navigation"
            :key="item.id"
          >
            <router-link
              v-if="item.type === 'Home'"
              :to="{ name: item.type, path: item.slug }"
              as="router-link"
              :class="[
                item.current
                  ? hasToggleSticky
                    ? 'text-amber-500 hover:text-yellow-600'
                    : 'text-gray-800 hover:text-green-600 '
                  : hasToggleSticky
                    ? 'text-amber-500 hover:text-green-600'
                    : 'text-gray-800 hover:text-yellow-600',
                'font-bold duration-500 transition-all',
                'p-2 text-base xl:text-lg block cursor-pointer'
              ]"
              :aria-current="item.current ? 'page' : undefined"
            >
              {{ item.name }}
            </router-link>
            <router-link
              v-else
              :to="{
                name: item.type,
                path: item.slug,
                params: {
                  sector: item.slug,
                },
              }"
              as="router-link"
              :class="[
                item.current
                  ? hasToggleSticky
                    ? 'text-amber-500 hover:text-yellow-600'
                    : 'text-gray-800 hover:text-green-600 '
                  : hasToggleSticky
                    ? 'text-amber-500 hover:text-green-600'
                    : 'text-gray-800 hover:text-yellow-600',
                'font-bold duration-500 transition-all',
                'p-2 text-base xl:text-lg block cursor-pointer'
              ]"
              :aria-current="item.current ? 'page' : undefined"
              @click="setCurrentSectorAndCategory(item, null)"
            >
              {{ item.name }}
            </router-link>
          </template>
        </DisclosureButton>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useMiscStore } from '@/stores/misc';
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Bars3Icon, BellIcon, XMarkIcon, ArrowRightStartOnRectangleIcon, MagnifyingGlassIcon } from '@heroicons/vue/24/outline'

const store = useMiscStore();
const route = useRoute();

// No need for manual active state management anymore

const navigation = computed(() => store.sectors),
   authNavigation = [
    { name: 'Join Now', href: 'login', current: false },
  ],
   authStore = useAuthStore(),

   isGuest = computed(() => authStore.guest),
   authUser = computed(() => authStore.authUser),
   dashboardUrl = authStore.dashboardUrl(),
   profileUrl = authStore.profileUrl(),
    hasToggleSticky = false,
   setCurrentSectorAndCategory = (sector, category) => {
     store.setCurrentSector(sector);
     store.setCurrentCategory(category);
   };
</script>
<style scoped>
.logo-title {
  font-family: "Verdana", "Roboto",serif;
}
</style>
